import React from "react";

export default function Fees({ elem, credit, onChangeData }) {
  return (
    <div className="mb-2">
      <label for="comentario">
        {elem.label}
        <span className="obligatory"> *</span>
      </label>
      <input
        type="text"
        className="amountForm form-control input-sm textInput especialGroup formHover"
        name={elem.id}
        value={credit.fees}
        onChange={(e) => onChangeData(e.target.value, e.target.id)}
        id={elem.id}
        aria-describedby="comentarioHelp"
        placeholder={elem.placeholder}
      />
    </div>
  );
}
